// extracted by mini-css-extract-plugin
module.exports = {"imgG":"ImgG_imgG__aBomT"};